import { baseUCGet } from '../base/baseUC';

//const dateTimeStr = new Date()?.toISOString();
const str = '';

export const bankModelGet = ({ userId = '', }) => {
    return {
        countryId: str,
        code: str,
        //created: dateTimeStr,
        description: str,
        rif: str,
        showBanks: false,
        //userId: userId,
        ...baseUCGet({ userId: userId, }),
    }
};